export default "images/FitChicks_scene_sm.png";